<template lang="html">
  <section class="employers">
    <h3 class="employers--no-results" v-if="employers.length === 0 && !filtering">
      {{ $t("generals.employeesfounded") }}
    </h3>
    <sui-grid
      v-else
      class="employers__container"
      :columns="columns === 4 ? 6 : 2"
      v-for="i in Math.ceil(employersWithIndex.length / 6)"
      :key="i"
    >
      <sui-grid-row>
        <sui-grid-column
          v-for="(employer, index) in employersWithIndex.slice((i - 1) * 6, i * 6)"
          :key="index"
        >
          <transition-group
            name="staggered-fade"
            :css="false"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
            tag="div"
            class="employers__item"
          >
            <div :key="index" v-show="visible" :data-index="employer.index">
              <img :src="employer.image" />
              <div class="employers__item__infos">
                <h2 class="employers__item__infos--title">{{ employer.name }}</h2>
                <h3 class="employers__item__infos--role">{{ employer.position }}</h3>
                <a class="employers__item__infos--link" @click="sendMail(employer.contact)">
                  {{ $t("generals.getcontact") }}
                </a>
              </div>
            </div>
          </transition-group>
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>

    <transition
      name="fadeIn"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in"
    >
      <div
        class="employers__see-more"
        v-if="employersWithIndex.length > 11 && employersWithIndex.length !== employers.length"
        @click="seeMore"
      >
        +
      </div>
    </transition>
  </section>
</template>

<script lang="js">
import Velocity from "velocity-animate";

  export default  {
    name: 'employers',
    props: {
      employers: {
        type: Array,
      },
      visible: {
        type: Boolean,
        default: true,
      },
      columns: {
        type: Number,
      },
      fetching: {
        type: Boolean,
        default: true,
      },
      filtering: {
        type: Boolean,
        default: true,
      }
    },
    data () {
      return {
        offset: 1,
        employersCopy: [],
      }
    },

    watch: {
      employers() {
        this.offset = 1;
      }
    },

    computed: {
      employersWithIndex() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.employersCopy = this.employers.map((item, index) => {

          return {
            ...item,
            index: index + 1,
          }
        });

        return this.employersCopy.slice(0, (12 * this.offset));
      }
    },

    methods: {
      sendMail(contact) {
        window.location.href = `mailto:${contact}`;
      },

      seeMore() {
        this.offset += 1;
        this.employersCopy = this.employers.slice(0, (12 * this.offset));
      },

      beforeEnter(el) {
        const $el = el;
        $el.style.opacity = 0;
      },

      enter(el, done) {
        const delay = el.dataset.index * 100;

        setTimeout(() => {
          Velocity(el, { opacity: 1 }, { complete: done });
        }, delay);
      },

      leave(el, done) {
        const delay = el.dataset.index * 20;

        setTimeout(() => {
          Velocity(el, { opacity: 0 }, { complete: done });
        }, delay);
      },
    },
}
</script>

<style scoped lang="scss">
.employers {
  &--no-results {
    color: white;
    width: 100%;
    text-align: center;
    font-weight: 300;
    font-size: 25px;
    max-width: 90%;
    margin: 0 auto;
  }

  img {
    width: 100%;
    margin-bottom: 20px;
  }

  a {
    cursor: pointer;
  }

  &__item {
    margin-bottom: 30px;

    &__infos {
      color: white;
      max-width: 320px;
      font-size: 26px;
      font-weight: 300;

      &--title {
        margin: 0;
        position: relative;
        font-weight: 300;
        font-size: 1.5vw;
        font-family: $david;
      }

      &--role {
        margin: 3px 0;
      }

      &--link {
        color: white;
        font-size: 13px;
        font-family: $tertiary;
        text-transform: uppercase;
      }
    }
  }

  &__see-more {
    font-size: 100px;
    color: white;
    font-weight: 300;
    text-align: center;
    width: 160px;
    margin: 0 auto;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    margin-top: 10px;

    &:hover {
      transition: all 0.2s ease-in-out;
      color: white;
    }
  }
}

@media (max-width: 1400px) {
  .employers {
    &__item {
      &__infos {
        font-size: 20px;

        &--title {
          font-size: 22px;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .employers {
    &__item {
      &__infos {
        font-size: 17px;

        &--title {
          font-size: 17px;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .employers {
    .column {
      padding: 0 5px !important;
    }

    &__see-more {
      margin: -20px auto 100px;
      font-size: 25px;
      width: 120px;
    }
  }
}
</style>
